export const getDropdownFilterGenerator = () => {
    return {
        i18n: "installationoverview.generator",
        label: "Generator",
        id: "generator",
        options: [
            {
                type: "check",
                variable: "state",
                options: [
                    {
                        id: "stopped",
                        i18n: "installationoverview.generator_state.stopped",
                        label: "Stopped",
                        variable: "Stopped",
                        value: false
                    },
                    {
                        id: "manual",
                        i18n: "installationoverview.generator_state.manual_run",
                        label: "Manual run",
                        variable: "Manual",
                        value: false
                    },
                    {
                        id: "auto",
                        i18n: "installationoverview.generator_state.auto_run",
                        label: "Auto run",
                        variable: "Auto",
                        value: false
                    },
                ]
            },
            {
                type: "minMax",
                i18n: "installationoverview.generator",
                label: "Generator",
                variable: "generator",
                min: "",
                max: "",
                measure: "watt" // used with class ::before
            },
            {
                type: "minMax",
                i18n: "installationoverview.serviceTime",
                label: "Runtime until service",
                variable: "runtime",
                min: "",
                max: "",
                measure: "hour" // used with class ::before
            },
            // {
            //     type: 'minMax',
            //     i18n: "installationoverview.runningSince",
            //     label: 'Running since',
            //     variable: 'running',
            //     min: '',
            //     max: '',
            //     measure: 'hour', // used with class ::before
            // },
        ]
    };
};
